import { lazyWithRetry } from '../utils/lazyRetry';

// Admin Components
export const AdminDashboard = lazyWithRetry(() => import('./Admin/AdminDashboard/AdminDashboard'));
export const AdminDCSApi = lazyWithRetry(() => import('./Admin/AdminDCSApi/AdminDCSApi'));
export const AdminAIAssistants = lazyWithRetry(() => import('./Admin/AdminAIAssistants'));
export const AdminGeolocation = lazyWithRetry(
  () => import('./Admin/AdminGeolocation/AdminGeolocation')
);
export const AdminNewUser = lazyWithRetry(() => import('./Admin/AdminNewUser/AdminNewUser'));
export const EditUser = lazyWithRetry(() => import('./Admin/AdminUser/EditUser'));
export const AdminUsers = lazyWithRetry(() => import('./Admin/AdminUsers/AdminUsers'));
export const AdminVideos = lazyWithRetry(() => import('./Admin/AdminVideos/AdminVideos'));
export const AdminCharts = lazyWithRetry(() => import('./Admin/AdminCharts/AdminCharts'));
export const AdminDocLibrary = lazyWithRetry(
  () => import('./Admin/AdminDocLibrary/AdminDocLibrary')
);
export const AdminBuyerNames = lazyWithRetry(
  () => import('./Admin/AdminBuyerNames/AdminBuyerNames')
);
export const AdminLpEstBillingDetail = lazyWithRetry(
  () => import('./Admin/AdminLpEstBillingDetail/AdminLpEstBillingDetail')
);
export const AdminLpDailyLog = lazyWithRetry(
  () => import('./Admin/AdminLpDailyLog/AdminLpDailyLog')
);
export const AdminLoginLog = lazyWithRetry(() => import('./Admin/AdminLoginLog/AdminLoginLog'));
export const ReleaseNotes = lazyWithRetry(() => import('./Admin/ReleaseNotes/ReleaseNotes'));
export const AdminLogs = lazyWithRetry(() => import('./Admin/AdminLogs'));
export const AdminFTPStatus = lazyWithRetry(() => import('./Admin/AdminFTPStatus/AdminFTPStatus'));
export const AdminTestFileGenerator = lazyWithRetry(
  () => import('./Admin/AdminTestFileGenerator/AdminTestFileGenerator')
);
export const AdminDatabaseInfo = lazyWithRetry(
  () => import('./Admin/AdminDatabaseInfo/AdminDatabaseInfo')
);
export const AdminBlackBook = lazyWithRetry(() => import('./Admin/AdminBlackBook/AdminBlackBook'));
export const AdminBugReports = lazyWithRetry(
  () => import('./Admin/AdminBugReports/AdminBugReports')
);
export const AdminReportTemplates = lazyWithRetry(
  () => import('./Admin/AdminReportTemplates/AdminReportTemplates')
);
export const AdminImportsMonitor = lazyWithRetry(
  () => import('./Admin/AdminImportsMonitor/AdminImportsMonitor')
);
export const AdminDocuSign = lazyWithRetry(() => import('./Admin/AdminDocuSign/AdminDocuSign'));
export const AdminPowerBI = lazyWithRetry(() => import('./Admin/AdminPowerBI/AdminPowerBI'));
export const AdminLoansToLeases = lazyWithRetry(
  () => import('./Admin/AdminPowerBI/AdminLoansToLeases')
);
export const AdminARaging = lazyWithRetry(() => import('./Admin/AdminPowerBI/AdminARaging'));

// AI Chat
export const AIChat = lazyWithRetry(() => import('./AIChat/AIChat'));

// Borrowing Base Components
export const BorrowingBase = lazyWithRetry(() => import('./BorrowingBase/BorrowingBase'));
export const BorrowingBaseBilling = lazyWithRetry(
  () => import('./BorrowingBase/BorrowingBaseBilling')
);
export const BorrowingBaseBillingLogs = lazyWithRetry(
  () => import('./BorrowingBase/BorrowingBaseBillingLogs')
);
export const BorrowingBaseCurrentAR = lazyWithRetry(
  () => import('./BorrowingBase/BorrowingBaseCurrentAR')
);
export const BorrowingBaseDashboard = lazyWithRetry(
  () => import('./BorrowingBase/BorrowingBaseDashboard')
);
export const BorrowingBaseDocuSignDocs = lazyWithRetry(
  () => import('./BorrowingBase/BorrowingBaseDocuSignDocs')
);
export const BorrowingBaseTransactions = lazyWithRetry(
  () => import('./BorrowingBase/BorrowingBaseTransactions')
);

// Dealer Components
export const Dealers = lazyWithRetry(() =>
  import('./Dealers/Dealers').then(module => ({ default: module.Dealers }))
);
export const DealerDetail = lazyWithRetry(() => import('./Dealers/DealerDetail'));
export const DealerBillingOptions = lazyWithRetry(() => import('./Dealers/DealerBillingOptions'));
export const DealerContacts = lazyWithRetry(
  () => import('./Dealers/DealerContacts/DealerContacts')
);
export const DealerNewContact = lazyWithRetry(() => import('./Dealers/DealerContacts/NewContact'));
export const DealerEditContact = lazyWithRetry(
  () => import('./Dealers/DealerContacts/EditContact')
);
export const DealerCorporateDocs = lazyWithRetry(() => import('./Dealers/DealerCorporateDocs'));
export const DealerBorrowingBase = lazyWithRetry(() => import('./Dealers/DealerBorrowingBase'));
export const DealerDefaults = lazyWithRetry(
  () => import('./Dealers/DealerDefaults/DealerDefaults')
);
export const DealerDMSGPSInfo = lazyWithRetry(() => import('./Dealers/DealerDMSGPSInfo'));
export const DealerMap = lazyWithRetry(() => import('./Dealers/DealerMap'));
export const DealerPortalUsers = lazyWithRetry(
  () => import('./Dealers/DealerPortalUsers/DealerPortalUsers')
);
export const DealerNewPortalUser = lazyWithRetry(
  () => import('./Dealers/DealerPortalUsers/NewPortalUser')
);
export const DealerEditPortalUser = lazyWithRetry(
  () => import('./Dealers/DealerPortalUsers/EditPortalUser')
);
export const DealerRisk = lazyWithRetry(() => import('./Dealers/DealerRisk/DealerRisk'));
export const DealerUnitProjections = lazyWithRetry(() => import('./Dealers/DealerUnitProjections'));
export const DealerAdd = lazyWithRetry(() => import('./Dealers/DealerAdd'));

// Floorplan Components
export const FloorplansSummaryByDealer = lazyWithRetry(
  () => import('./Floorplans/FloorplansSummaryByDealer')
);
export const FloorplansDashboard = lazyWithRetry(() => import('./Floorplans/FloorplansDashboard'));
export const FloorplansPendingFunding = lazyWithRetry(
  () => import('./Floorplans/FloorplansPendingFunding')
);
export const FloorplanAddVehicle = lazyWithRetry(() => import('./Floorplans/FloorplanAddVehicle'));
export const FloorplanAddVendor = lazyWithRetry(() => import('./Floorplans/FloorplanAddVendor'));
export const FloorplanVendors = lazyWithRetry(() => import('./Floorplans/FloorplanVendors'));
export const FloorplansFunding = lazyWithRetry(() => import('./Floorplans/FloorplansFunding'));
export const FloorplansCancelFunding = lazyWithRetry(
  () => import('./Floorplans/FloorplansCancelFunding')
);
export const FloorplansActiveVehicles = lazyWithRetry(
  () => import('./Floorplans/FloorplansActiveVehicles')
);
export const FloorplansActiveVehiclesDetail = lazyWithRetry(
  () => import('./Floorplans/ActiveVehiclesDetail/FloorplansActiveVehiclesDetail')
);
export const FloorplanBilling = lazyWithRetry(() => import('./Floorplans/FloorplanBilling'));
export const FloorplansPayoffRequests = lazyWithRetry(
  () => import('./Floorplans/FloorplansPayoffRequests')
);
export const FloorplansBulkPayoff = lazyWithRetry(
  () => import('./Floorplans/FloorplansBulkPayoff')
);
export const FloorplansPaidOffVehicles = lazyWithRetry(
  () => import('./Floorplans/FloorplansPaidOffVehicles')
);
export const FloorplansFundingLog = lazyWithRetry(
  () => import('./Floorplans/FloorplansFundingLog')
);
export const FloorplansFundingLogDetail = lazyWithRetry(
  () => import('./Floorplans/FloorplansFundingLogDetail')
);
export const FloorplansBillingPaymentLog = lazyWithRetry(
  () => import('./Floorplans/FloorplansBillingPaymentLog')
);
export const FloorplansBillingPaymentLogDetail = lazyWithRetry(
  () => import('./Floorplans/FloorplansBillingPaymentLogDetail')
);
export const FloorplansAssignLender = lazyWithRetry(
  () => import('./Floorplans/FloorplansAssignLender')
);
export const FloorplansBalanceHistory = lazyWithRetry(
  () => import('./Floorplans/FloorplansBalanceHistory')
);

// Home Components
export const HomeBorrowingBaseReports = lazyWithRetry(
  () => import('./Home/HomeBorrowingBaseReports')
);
export const HomeBulkLoanPlanBilling = lazyWithRetry(
  () => import('./Home/HomeBulkLoanPlanBilling')
);
export const HomeDashboards = lazyWithRetry(() => import('./Home/Dashboards/HomeDashboards'));
export const HomeDocuSignStatus = lazyWithRetry(() => import('./Home/HomeDocuSignStatus'));
export const HomeExports = lazyWithRetry(() => import('./Home/HomeExports'));
export const HomeExportsDetail = lazyWithRetry(() => import('./Home/HomeExportsDetail'));
export const HomeNewsInfo = lazyWithRetry(() => import('./Home/HomeNewsInfo'));
export const HomeNewsInfoAddNew = lazyWithRetry(() => import('./Home/HomeNewsInfoAddNew'));
export const HomePrimeRateHistory = lazyWithRetry(() => import('./Home/HomePrimeRateHistory'));
export const HomeLeaseQuote = lazyWithRetry(() => import('./Home/HomeLeaseQuote/LeaseQuote'));
export const HomeVinSearch = lazyWithRetry(() => import('./Home/HomeVinSearch'));
// Phone Directory disabled v0.63.8 — `phoneext` table is empty.
// export const HomeDirectory = lazyWithRetry(() => import('./Home/HomeDirectory/HomeDirectory'));
export const HomeCalendar = lazyWithRetry(() => import('./Home/HomeCalendar/HomeCalendar'));

// Import Components
export const ImportsSummary = lazyWithRetry(() => import('./Imports/ImportsSummary'));
export const ImportsCheckForDuplicates = lazyWithRetry(
  () => import('./Imports/ImportsCheckForDuplicates')
);
export const ImportsCurrentDealerAR = lazyWithRetry(
  () => import('./Imports/ImportsCurrentDealerAR')
);
export const ImportsARAged = lazyWithRetry(() => import('./Imports/ImportsARAged'));
export const ImportsARBalance = lazyWithRetry(() => import('./Imports/ImportsARBalance'));
export const ImportsAccDepreciation = lazyWithRetry(
  () => import('./Imports/ImportsAccDepreciation')
);
export const ImportsBHPHLoanRequests = lazyWithRetry(
  () => import('./Imports/ImportsBHPHLoanRequests')
);
export const ImportsInterestBalance = lazyWithRetry(
  () => import('./Imports/ImportsInterestBalance')
);
export const ImportsFloorplanRequest = lazyWithRetry(
  () => import('./Imports/ImportsFloorplanRequest')
);
export const ImportsIndirectLoanRequests = lazyWithRetry(
  () => import('./Imports/ImportsIndirectLoanRequests')
);
export const ImportsLoanRequests = lazyWithRetry(() => import('./Imports/ImportsLoanRequests'));
export const ImportsPremierLoanRequests = lazyWithRetry(
  () => import('./Imports/ImportsPremierLoanRequests')
);
export const ImportsRefiSwapPremierConversion = lazyWithRetry(
  () => import('./Imports/ImportsRefiSwapPremierConversion')
);
export const ImportsUnsoldInventory = lazyWithRetry(
  () => import('./Imports/ImportsUnsoldInventory')
);
export const ImportsVinToStockNumXref = lazyWithRetry(
  () => import('./Imports/ImportsVinToStockNumXref')
);
export const ImportsWholesaleInventory = lazyWithRetry(
  () => import('./Imports/ImportsWholesaleInventory')
);

// Loan Components
export const LoansHome = lazyWithRetry(() =>
  import('./Loans/LoansHome').then(module => ({ default: module.LoansHome }))
);
export const LoansBilling = lazyWithRetry(() => import('./Loans/LoansBilling'));
export const LoansActiveLoans = lazyWithRetry(() => import('./Loans/LoansActiveLoans'));
export const LoansActiveLoansDetail = lazyWithRetry(
  () => import('./Loans/ActiveLoansDetail/LoansActiveLoansDetail')
);
export const LoansBillingPaymentLog = lazyWithRetry(() => import('./Loans/LoansBillingPaymentLog'));
export const LoansBillingPaymentLogDetail = lazyWithRetry(
  () => import('./Loans/LoansBillingPaymentLogDetail')
);
export const LoansCloseFullTermLoans = lazyWithRetry(
  () => import('./Loans/LoansCloseFullTermLoans')
);
export const LoanDashboard = lazyWithRetry(() => import('./Loans/LoansDashboard/LoansDashboard'));
export const LoansDocuSignStatus = lazyWithRetry(() => import('./Loans/LoansDocuSignStatus'));
export const LoansExceptionsMaintenance = lazyWithRetry(
  () => import('./Loans/LoansExceptionsMaintenance')
);
export const LoansFundingLog = lazyWithRetry(() => import('./Loans/LoansFundingLog'));
export const LoansFundingLogDetail = lazyWithRetry(() => import('./Loans/LoansFundingLogDetail'));
export const LoansLoanCalculator = lazyWithRetry(() => import('./Loans/LoansLoanCalculator'));
export const LoansLoanPlanPayoffRequests = lazyWithRetry(
  () => import('./Loans/LoansLoanPlanPayoffRequests')
);
export const LoansBulkPayoffRequests = lazyWithRetry(
  () => import('./Loans/LoansBulkPayoffRequests')
);
export const LoansPayoffRequestsList = lazyWithRetry(
  () => import('./Loans/LoansPayoffRequestsList')
);
export const LoansLoanPlanBulkPayoff = lazyWithRetry(
  () => import('./Loans/ActiveLoansDetail/LoansLoanPlanBulkPayoff')
);
export const LoansRepoSwap = lazyWithRetry(() => import('./Loans/ActiveLoansDetail/LoansRepoSwap'));
export const LoansCancelSwapRequest = lazyWithRetry(() => import('./Loans/LoansCancelSwapRequest'));
export const MatchupExceptions = lazyWithRetry(() => import('./Loans/LoansMatchupExceptions'));
export const MatchupExceptionDetail = lazyWithRetry(
  () => import('./Loans/LoansMatchupExceptionDetail')
);
export const LoansLoanMatchStatus = lazyWithRetry(() => import('./Loans/LoansLoanMatchStatus'));
export const LoansMoveLoansToFloorplan = lazyWithRetry(
  () => import('./Loans/LoansMoveLoansToFloorplan')
);
export const LoansPaidOffLoans = lazyWithRetry(() => import('./Loans/LoansPaidOffLoans'));
export const LoansPaidOffCalculator = lazyWithRetry(() => import('./Loans/LoansPaidOffCalculator'));
export const LoansPendingFunding = lazyWithRetry(() => import('./Loans/LoansPendingFunding'));
export const LoansPendingQueue = lazyWithRetry(() => import('./Loans/LoansPendingQueue'));
export const LoansPendingRepoSwaps = lazyWithRetry(() => import('./Loans/LoansPendingRepoSwaps'));
export const LoansRepoSwapApproval = lazyWithRetry(() => import('./Loans/LoansRepoSwapApproval'));
export const LoanToLeaseMatchup = lazyWithRetry(() =>
  import('./Loans/LoanToLeaseMatchup/LoanToLeaseMatchup').then(module => ({
    default: module.LoanToLeaseMatchup,
  }))
);
export const LoansAddLoan = lazyWithRetry(() => import('./Loans/LoansAddLoan'));
export const LoansFundLoans = lazyWithRetry(() => import('./Loans/LoansFundLoans'));
export const LoansCancelLoanRequests = lazyWithRetry(
  () => import('./Loans/LoansCancelLoanRequests')
);
export const LoansTrancheExceptions = lazyWithRetry(() => import('./Loans/LoansTrancheExceptions'));

// Report Components
export const ReportsAllReports = lazyWithRetry(() => import('./Reports/ReportsAllReports'));
export const DealerReports = lazyWithRetry(() => import('./Reports/DealerReports'));
export const ReportsCreditLines = lazyWithRetry(() => import('./Reports/ReportsCreditLines'));
export const ReportsEmailReports = lazyWithRetry(
  () => import('./Reports/EmailReports/ReportsEmailReports')
);
export const ReportsFloorplans = lazyWithRetry(() => import('./Reports/ReportsFloorplans'));

// Settings Components
export const SettingsStaffUsers = lazyWithRetry(() => import('./Settings/SettingsStaffUsers'));
export const SettingsSignatures = lazyWithRetry(() => import('./Settings/SettingsSignatures'));
export const SettingsEmailTemplates = lazyWithRetry(
  () => import('./Settings/SettingsEmailTemplates')
);
export const SettingsRoboTemplates = lazyWithRetry(
  () => import('./Settings/SettingsRoboTemplates')
);
export const SettingsLetterTemplates = lazyWithRetry(
  () => import('./Settings/SettingsLetterTemplates')
);
export const SettingsTextTemplates = lazyWithRetry(
  () => import('./Settings/SettingsTextTemplates')
);

// Other Components
export const UserProfile = lazyWithRetry(() => import('./User/UserProfile'));
export const VideoTraining = lazyWithRetry(() =>
  import('./VideoTraining/VideoTraining').then(module => ({ default: module.VideoTraining }))
);
export const UnderConstructionPage = lazyWithRetry(() => import('./UnderConstructionPage'));
